/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaOfInterest } from '../../models/area-of-interest';

export interface GetStudentProfileAreaOfInterests$Params {
  profileId: string;
}

export function getStudentProfileAreaOfInterests(http: HttpClient, rootUrl: string, params: GetStudentProfileAreaOfInterests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AreaOfInterest>>> {
  const rb = new RequestBuilder(rootUrl, getStudentProfileAreaOfInterests.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AreaOfInterest>>;
    })
  );
}

getStudentProfileAreaOfInterests.PATH = '/studentprofile/{profileId}/areaofinterest';
